import { createApi } from '@reduxjs/toolkit/query/react';
// eslint-disable-next-line boundaries/element-types
import baseQueryWithReAuth from '../../../baseQueryWithReAuth/baseQueryWithReAuth';
import reducerPath from '../../../../app/reducerPath';
import config from '../../../../shared/api/config';
import HttpMethods from '../../../../shared/api/HttpMethods';
import checkStatus from '../../../../shared/http/checkStatus';

const TAG = 'sensor-values';
const url = `/${TAG}`;

// Описываем методы обращения к беку
export const sensorValuesResourceApi = createApi({
  reducerPath: `${reducerPath.sensorValues}/api`,
  tagTypes: [TAG],
  baseQuery: (...arg) => baseQueryWithReAuth(...arg, `${config.vstorageUrl}`),
  endpoints: (builder) => ({
    exportSensorValuesAsync: builder.query({
      query: ({ params }) => ({
        url: `${url}/export/async`,
        method: HttpMethods.GET,
        params,
        validateStatus: checkStatus,
      }),
      providesTags: [TAG],
    }),

    getExportStatus: builder.query({
      query: (fileName) => ({
        url: `${url}/export/status/${fileName}`,
        method: HttpMethods.GET,
        validateStatus: checkStatus,
      }),
      providesTags: [TAG],
    }),

    stopExport: builder.mutation({
      query: (fileName) => ({
        url: `${url}/export/${fileName}/stop`,
        method: HttpMethods.POST,
        validateStatus: checkStatus,
      }),
    }),

    getSensorValues: builder.query({
      query: ({ params }) => ({
        url: `${url}`,
        method: HttpMethods.GET,
        params,
        validateStatus: checkStatus,
      }),
      providesTags: [TAG],
    }),
  }),
});

export const {
  useLazyExportSensorValuesAsyncQuery,
  useGetExportStatusQuery,
  useLazyGetExportStatusQuery,
  useGetSensorValuesQuery,
  useLazyGetSensorValuesQuery,
  useStopExportMutation,
} = sensorValuesResourceApi;
